<script module lang="ts">
  // Harmonize the button width across components
  let buttonMinWidth = $state(0)
</script>
<script lang="ts">
  import { icon } from '#app/lib/icons'
  import { buildPath } from '#app/lib/location'
  import { onChange } from '#app/lib/svelte/svelte'
  import { arrayIncludes, loadInternalLink } from '#app/lib/utils'
  import { defaultWorkP31PerSerieP31 } from '#entities/components/lib/claims_helpers'
  import type { SubEntitiesBrowserSectionData } from '#entities/components/lib/entities'
  import { locallyCreatableEntitiesTypes } from '#entities/lib/editor/properties_per_type'
  import type { RelativeUrl } from '#server/types/common'
  import { I18n } from '#user/lib/i18n'

  const {
    section,
  }: {
    section: SubEntitiesBrowserSectionData
  } = $props()

  const parentUri = $derived(section.parentUri)
  const parentEntity = $derived(section.parentEntity)
  const subEntityType = $derived(section.subEntityType)
  const subEntityRelationProperty = $derived(section.subEntityRelationProperty)

  const createButtonHref: RelativeUrl = $derived.by(() => {
    if (parentUri && subEntityType && subEntityRelationProperty && arrayIncludes(locallyCreatableEntitiesTypes, subEntityType)) {
      const claims = { [subEntityRelationProperty]: [ parentUri ] }
      const parentP31 = parentEntity.claims['wdt:P31']
      if (parentEntity.type === 'serie' && parentP31.length === 1) {
        const inheritedP31 = defaultWorkP31PerSerieP31[parentP31[0]]
        if (inheritedP31) claims['wdt:P31'] = [ inheritedP31 ]
      }
      return buildPath('/entity/new', { type: subEntityType, claims })
    }
  })

  let buttonWidth = $state(0)
  $effect(() => {
    onChange(buttonWidth, () => {
      buttonMinWidth = Math.max(buttonMinWidth, buttonWidth)
    })
  })
</script>

<!-- TODO?: offer the possibility to search among existing entities, rather than creating a new one -->
{#if createButtonHref}
  <a
    href={createButtonHref}
    onclick={loadInternalLink}
    class="tiny-button"
    bind:clientWidth={buttonWidth}
    style:min-width="{buttonMinWidth}px"
  >
    {@html icon('plus')}
    {I18n(`create a new ${subEntityType}`)}
  </a>
{:else}
  <div class="placeholder" style:min-width="{buttonMinWidth}px"></div>
{/if}

<style lang="scss">
  @import "general/scss/utils";
  .tiny-button, .placeholder{
    display: inline-block;
    margin: 0.5em;
    align-self: flex-end;
  }
</style>
